<template>

    <!-- [ Menu ] start -->
    <div class="menu" :class="{animation: sidebarOpened}">
        <!--{{sidebarOpened}}-->
        <div class="menu__content">
            <el-menu
                    default-active="2"
                    class="el-menu-vertical-demo"
                    @open="handleOpen"
                    @close="handleClose"
                    background-color="#f2f4f7"
                    text-color="#303133"
                    active-text-color="#303133"
                    :unique-opened="true"
                    :router="true">
              <li>
                <router-link :to="`/settings-dashboard?companyId=${this.$route.query.companyId}`" class="menu_title">Settings Dashboard</router-link>
              </li>
              <el-submenu index="1">
                  <template slot="title">
                      <span>{{$t('menu_organisation_title')}}</span>
                  </template>
                  <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_information')" :index="`/about?companyId=${this.$route.query.companyId}`">{{$t('menu_organisation_about')}}</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_dataRooms')" :index="`/dataRooms?companyId=${this.$route.query.companyId}`">{{$t('menu_organisation_dataRooms')}}</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_settings')" :index="`/settings?companyId=${this.$route.query.companyId}&coa=true`">{{$t('menu_accountancy_chart_of_accounts')}}</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_businessCentres', true)" class="support_link">{{$t('menu_organisation')}}</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                      <el-menu-item class="flex" @click="goToBusinessUnits()">
                        <div class="colorMenu">{{$t('menu_management_bu')}}</div>
                        <div><span class="stat" v-html="statistics.businessUnitCount"></span></div>
                      </el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_reports', true)" class="support_link">{{$t('menu_centers_reports')}}</el-menu-item>
                  </el-menu-item-group>
              </el-submenu>
              <el-submenu index="8">
                  <template slot="title">
                      <span>{{$t('menu_compliance')}}</span>
                  </template>
                  <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_statutory', true)" class="support_link">{{$t('menu_compliance_statutory')}}</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_regulatory', true)" class="support_link">{{$t('menu_compliance_regulatory')}}</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_taxation', true)" class="support_link">{{$t('menu_compliance_taxation')}}</el-menu-item>
                  </el-menu-item-group>
              </el-submenu>
              <el-submenu index="10">
                  <template slot="title">
                      <span>{{$t('menu_people')}}</span>
                  </template>
                  <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_users')" class="flex" :index="`/users?companyId=${this.$route.query.companyId}${$route.query.companyUserId ? '&companyUserId=' + $route.query.companyUserId : ''}`">
                        <div>{{$t('menu_centers_users')}}</div>
                        <div><span class="stat" v-html="statistics.userCount"></span></div>
                      </el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_acquiring', true)" class="support_link">{{$t('menu_people_acquiring')}}</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_managing', true)" class="support_link">{{$t('menu_people_managing')}}</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_optimising', true)" class="support_link">{{$t('menu_people_optimising')}}</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_timekeeping', true)" class="support_link">{{$t('menu_payxoft_timekeeping')}}</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_leaveManagement', true)" class="support_link">{{$t('menu_payxoft_leave_management')}}</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_payRun', true)" class="support_link">{{$t('menu_payxoft_payroll')}}</el-menu-item>
                  </el-menu-item-group>
              </el-submenu>
              <el-submenu index="3">
                  <template slot="title">
                      <span>{{$t('menu_supply_chain')}}</span>
                  </template>
                  <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_vendors')" class="flex" v-if="companyLayout" :disabled="!companyLayout.permission.viewVendors" :index="`/vendors?companyId=${this.$route.query.companyId}`">
                        <div>{{$t('menu_centers_vendors')}}</div>
                        <div><span class="stat" v-html="statistics.companyVendorCount"></span></div>
                      </el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group v-if="companyLayout" >
                      <el-menu-item @click="logRequest('log_settings')" :disabled="!companyLayout.permission.viewItemsType" :index="`/settings?companyId=${this.$route.query.companyId}&items=true`">{{$t('menu_supply_chain_items')}}</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_purchasing')" v-if="companyLayout" :disabled="!companyLayout.permission.viewPurchasing" :index="`/purchases?companyId=${this.$route.query.companyId}`">{{$t('menu_supply_chain_purchasing')}}</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_spendManagement', true)" class="support_link">{{$t('menu_supply_chain_purchasing_control')}}</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_warehousing', true)" class="support_link">{{$t('menu_supply_chain_warehousing')}}</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_logistics', true)" class="support_link">{{$t('menu_supply_chain_logistics')}}</el-menu-item>
                  </el-menu-item-group>
                  <!-- <el-menu-item-group>
                      <el-menu-item :index="`/vendor-invoices?companyId=${this.$route.query.companyId}`">Vendor Invoices</el-menu-item>
                  </el-menu-item-group> -->
              </el-submenu>
              <el-submenu index="2">
                  <template slot="title">
                      <span>{{$t('menu_customer_relationship')}}</span>
                  </template>
                  <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_clients')" class="flex" v-if="companyLayout" :disabled="!companyLayout.permission.viewClients" :index="`/clients?companyId=${this.$route.query.companyId}`">
                        <div>{{$t('menu_centers_clients')}}</div>
                        <div><span class="stat" v-html="statistics.companyClientCount"></span></div>
                      </el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                      <el-menu-item v-if="companyLayout" :disabled="!companyLayout.permission.viewEngagements" class="flex" @click="goToEngagements()">
                        <div class="colorMenu">{{$t('menu_management_e')}}</div>
                        <div><span class="stat" v-html="statistics.engagementCount"></span></div>
                      </el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                      <el-menu-item class="flex" @click="goToProjects()">
                        <div class="colorMenu">{{$t('menu_management_project')}}</div>
                        <div><span class="stat" v-html="statistics.projectCount"></span></div>
                      </el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group v-if="companyLayout" >
                      <el-menu-item @click="logRequest('log_settings')" :disabled="!companyLayout.permission.viewItemsType" :index="`/settings?companyId=${this.$route.query.companyId}&items=true`">{{$t('menu_customer_relationship_items')}}</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_selling', true)" class="support_link">{{$t('menu_customer_relationship_selling')}}</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_delivering', true)" class="support_link">{{$t('menu_customer_relationship_delivering')}}</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_accountsReceivable', true)" class="support_link">{{$t('menu_customer_relationship_accounts_receivable')}}</el-menu-item>
                  </el-menu-item-group>
              </el-submenu>
              <!-- <el-submenu index="5">
                  <template slot="title">
                      <span>{{$t('menu_centres')}}</span>
                  </template>
                  <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_users')" class="flex" :index="`/users?companyId=${this.$route.query.companyId}${$route.query.companyUserId ? '&companyUserId=' + $route.query.companyUserId : ''}`">
                        <div>{{$t('menu_centers_users')}}</div>
                        <div><span class="stat" v-html="statistics.userCount"></span></div>
                      </el-menu-item>
                  </el-menu-item-group>
                 <el-menu-item-group>
                     <el-menu-item class="flex" :index="`/shared-projects?companyId=${this.$route.query.companyId}`">
                       <div>{{$t('menu_centers_sharing')}}</div>
                       <div><span class="stat" v-html="statistics.sharedProjectTaskCount"></span></div>
                     </el-menu-item>
                 </el-menu-item-group>
                  <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_reports')" disabled index="/">{{$t('menu_centers_reports')}}</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_importExport')" disabled index="/">{{$t('menu_centres_import_export')}}</el-menu-item>
                  </el-menu-item-group>
              </el-submenu> -->
              <li>
                <router-link :to="`/account-think?companyId=${this.$route.query.companyId}`" class="menu_title">{{$t('menu_accountTHINK')}}</router-link>
              </li>
<!--              <el-submenu index="9">-->
<!--                <template slot="title">-->
<!--                  <span>{{$t('menu_accountTHINK')}}</span>-->
<!--                </template>-->
<!--                <el-menu-item-group>-->
<!--                  <el-menu-item class="support_link" :index="`/general-ledger?companyId=${this.$route.query.companyId}`">{{$t('menu_finance_pay_generalLedger')}}</el-menu-item>-->
<!--                </el-menu-item-group>-->
<!--              </el-submenu>-->
              <el-submenu index="6">
                  <template slot="title">
                      <span>{{$t('menu_accountancy')}}</span>
                  </template>
                  <!-- <el-menu-item-group>
                      <el-menu-item :index="`/settings?companyId=${this.$route.query.companyId}&at=true`">{{$t('menu_accountancy_settings')}}</el-menu-item>
                  </el-menu-item-group> -->
                  <!-- <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_settings')" :index="`/settings?companyId=${this.$route.query.companyId}&coa=true`">{{$t('menu_accountancy_chart_of_accounts')}}</el-menu-item>
                  </el-menu-item-group> -->
                  <el-menu-item-group>
                    <el-menu-item class="support_link" :index="`/general-ledger?companyId=${this.$route.query.companyId}`">{{$t('menu_finance_pay_generalLedger')}}</el-menu-item>
                  </el-menu-item-group>
                <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_budgets', true)" class="support_link">{{$t('menu_accountancy_budgets')}}</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_expenses')" v-if="companyLayout" :disabled="!companyLayout.permission.viewExpanses" :index="`/expenses?companyId=${this.$route.query.companyId}`">{{$t('menu_accountancy_expenses')}}</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_accountsPayable', true)" class="support_link">{{$t('menu_accountancy_accounts_payable')}}</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_liquidations')" v-if="companyLayout" :disabled="!companyLayout.permission.viewLiqudations" :index="`/cash-advance-liquidation?companyId=${this.$route.query.companyId}`">{{$t('menu_accountancy_liquidations')}}</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_journalEntries')" v-if="companyLayout" :disabled="!companyLayout.permission.viewTransactionJournal" :index="`/journal-and-gl?companyId=${this.$route.query.companyId}`">{{$t('menu_accountancy_journal_entries')}}</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_assetManagement', true)" class="support_link">{{$t('menu_accountancy_asset_management')}}</el-menu-item>
                  </el-menu-item-group>
              </el-submenu>
              <el-submenu index="7">
                  <template slot="title">
                      <span>{{$t('menu_finance')}}</span>
                  </template>
                  <el-menu-item-group>
                      <el-menu-item :index="`/settings-bank-accounts?companyId=${this.$route.query.companyId}`" class="support_link">{{$t('menu_finance_bank_accounts')}}</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                      <el-menu-item :index="`/settings-credit-cards-accounts?companyId=${this.$route.query.companyId}`" class="support_link">{{$t('menu_finance_credit_card_accounts')}}</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_cashAdvances')" :index="`/cash-advances?companyId=${this.$route.query.companyId}`">{{$t('menu_finance_cash_advances')}}</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_reconciliations', true)" class="support_link">{{$t('menu_finance_reconciliations')}}</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_receiveMoney', true)" class="support_link">{{$t('menu_finance_receive_money')}}</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_transferMoney', true)" class="support_link">{{$t('menu_finance_transfer_money')}}</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_payMoney', true)" class="support_link">{{$t('menu_finance_pay_money')}}</el-menu-item>
                  </el-menu-item-group>
              </el-submenu>
              <!-- <el-submenu index="4">
                  <template slot="title">
                      <span>Human Capital</span>
                  </template>
                  <el-submenu index="99">
                    <template disabled slot="title">Management</template>
                    <el-menu-item disabled index="/">
                      Acquiring
                    </el-menu-item>
                    <el-menu-item disabled index="/">
                      Managing
                    </el-menu-item>
                    <el-menu-item disabled index="/">
                      Optimising
                    </el-menu-item>
                  </el-submenu>
                  <el-menu-item-group>
                      <el-menu-item disabled index="/">Payroll</el-menu-item>
                  </el-menu-item-group>
              </el-submenu> -->

              <!-- <el-submenu index="88">
                  <template slot="title">
                      <span>{{$t('menu_regulatory')}}</span>
                  </template>
              </el-submenu> -->
              <!-- <el-submenu index="9">
                  <template slot="title">
                      <span>{{$t('menu_payxoft')}}</span>
                  </template>
                  <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_timekeeping')" disabled index="/">{{$t('menu_payxoft_timekeeping')}}</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_leaveManagement')" disabled index="/">{{$t('menu_payxoft_leave_management')}}</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                      <el-menu-item @click="logRequest('log_payRun')" disabled index="/">{{$t('menu_payxoft_payroll')}}</el-menu-item>
                  </el-menu-item-group>
              </el-submenu> -->
            </el-menu>

            <div class="menu__info">
                <!-- [ Logo ] start -->
                <router-link :to="`/projects?companyId=${this.$route.query.companyId}`">
                    <img src="../../assets/img/logo.png" alt="Totalflow" height="20px">
                </router-link> <br>
                <!-- [ Logo ] end -->
                <!-- <div class="menu__info_title">* Last updated:</div> -->
                <div v-for="news in newsMenu" :key="news.id" @click="openNews(news.translations[0].titleTranslation, news.createDate, news.translations[0].textTranslation)" class="menu__info_title" v-html="news.translations[0].titleTranslation"></div>
                <!-- <div class="menu__info_item">- Initial creation of basic</div>
                <div class="menu__info_item">- Initial creation of basic</div>
                <div class="menu__info_item">- Initial creation of basic</div>
                <div class="menu__info_item">- Initial creation of basic</div>
                <div class="menu__info_item">- Initial creation of basic</div> -->
                <!-- {{newsMenu}} -->
            </div>
        </div>

        <div class="menu__footer">
           <div v-if="companyLayout" class="menu__size">
             <div class="menu__size_item">{{$t('menu_storage_capacity')}}:</div>
             <el-tooltip effect="light" placement="bottom-start" :content="`You are currently using ${(companyLayout.storageSize / 1073741824).toFixed(2)} GB (${Math.round((100 * companyLayout.storageSize) / companyLayout.fullSize)} %) of your ${(companyLayout.fullSize / 1073741824).toFixed(2)} GB`">
              <div class="menu__size_item" style="cursor: pointer;"><el-progress :text-inside="true" :stroke-width="13" :percentage="Math.round((100 * companyLayout.storageSize) / companyLayout.fullSize)" :color="customColorMethod"></el-progress></div>
             </el-tooltip>
           </div>
            <div @click="sentsInvite" class="menu__invite">{{$t('menu_invite_company')}}</div>
            <!-- <div @click="sentsFeedback" class="menu__feedback">{{$t('menu_support')}}</div> -->
            <!-- [ Logo ] start -->
            <!-- <router-link :to="`/projects?companyId=${this.$route.query.companyId}`">
              <img src="../assets/img/logo_white.png" alt="Totalflow" height="15px">
            </router-link> <br> -->
            <!-- [ Logo ] end -->
            <span style="margin-left: 10px;">{{$t('menu_v')}}</span>
        </div>

        <Feedback ref="modal"/>

        <!-- [ Modal news] start -->
        <sweet-modal blocking :title="valueTitle" :subtitle="valueTime" ref="news" class="modal">
            <!-- <div class="modal__time" v-html="valueTime"></div> -->
            <!-- <h1 class="modal__title" v-html="valueTitle"></h1> -->
            <div class="modal__content" v-html="valueContent"></div>
        </sweet-modal>
        <!-- [ Modal news] end -->

        <!-- [ Modal Invite Company] start -->
        <sweet-modal blocking :title="$t('modal_invite_company')" ref="invite" class="modal" v-on:close="closeModal">

            <el-form @submit.prevent.native="submitForm('form')" :model="form" status-icon :rules="rules" ref="form" class="demo-ruleForm">
                <el-form-item prop="inviteEmail">
                    <el-input :label="$t('modal_email')" size="mini" v-model="form.inviteEmail"></el-input>
                </el-form-item>
                <el-form-item label-width="0" class="modal__btn">
                  <el-button @click="modalCancel('invite')">{{$t('general_cancel')}}</el-button>
                  <el-button @click="submitForm('form')" class="modal__btn" type="primary">{{$t('general_submit')}}</el-button>
                </el-form-item>
            </el-form>
        </sweet-modal>
        <!-- [ Modal Invite Company] end -->

        <sweet-modal title="tf Support" width="500" blocking ref="support">
          <div class="tf-support">
            <div>Sorry, this feature now under development will be ready later.</div>
          </div>
        </sweet-modal>
    </div>
    <!-- [ Menu ] end -->

</template>

<script>
  import log from '@/log/log.js'
  import moment from 'moment'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
  import Feedback from '@/components/Feedback.vue'
  import axios from 'axios'
  export default {
    name: 'sidebar',
    components: {
      SweetModal,

      Feedback,
    },
    props: {
      // open: {
      //   type: Boolean,
      //   required: true,
      //   default: false
      // },
    },
    data() {
      return {
        moment:moment,
        // companyId: '',
        // valueCompany: '',
        valueTitle: '',
        valueTime: '',
        valueContent: '',

        // Invite
        form: {
          inviteEmail: '',
        },
        rules: {
          inviteEmail: [
            { required: true, message: 'Please input Email address', trigger: 'blur' },
            { type: 'email', message: 'Please input correct email address', trigger: 'blur' }
          ],
        }
      }
    },
    mounted(){
      // this.$store.dispatch('loadUser')
      // if (sessionStorage.getItem('token')){
      //   console.log("LOCAL STORAGE", 'Bearer ' + sessionStorage.getItem('token'))
      //   // this.$socket.open();
      // }
      // setTimeout(() => {
      //   if(!localStorage.getItem('companyName')){
      //     console.log("companyNAME")
      //     this.valueCompany = this.user[0].name
      //   }else{
      //     this.valueCompany = localStorage.getItem('companyName');
      //   }
      // }, 1000)
    },
    computed: {
      sidebarOpened() {
        return this.$store.state.sidebar.opened
      },
      statistics() {
        return this.$store.getters.getMenuStatistics
      },
      user() {
        return this.$store.state.user
      },
      newsMenu() {
        return this.$store.state.newsMenu
      },
      companyLayout() {
        return this.$store.getters.getCompanyLayout
      },
    },
    methods: {
      logRequest(action, support) {
        if (support) {
          this.$refs.support.open()
        } else {
          log(`/api/v1/logs/create?companyId=${this.$route.query.companyId}`, {
            'action': action,
            'paramsLog': {}
          })
        }
      },
      customColorMethod(percentage) {
        if (percentage < 30) {
          return '#67c23a';
        } else if (percentage < 70) {
          return '#e6a23c';
        } else {
          return '#f56c6c';
        }
      },
      modalCancel(ref) {
        this.$refs[ref].close();
      },
      goToBusinessUnits(){
        if(this.$route.name === 'business-units' && this.$route.query.businessUnitId && this.$route.query.taskId){
          this.$router.push(`/business-units?companyId=${this.$route.query.companyId}&businessUnitId=${this.$route.query.businessUnitId}&taskId=${this.$route.query.taskId}`)
        }else if(this.$route.name === 'business-units' && this.$route.query.businessUnitId){
          this.$router.push(`/business-units?companyId=${this.$route.query.companyId}&businessUnitId=${this.$route.query.businessUnitId}`)
        }else{
          this.$router.push(`/business-units?companyId=${this.$route.query.companyId}`)
        }

        // Log bu
        log(`/api/v1/logs/create?companyId=${this.$route.query.companyId}`, {
          'action': 'log_bu',
          'paramsLog': {}
        })
      },
      goToEngagements(){
        if(this.$route.name === 'engagements' && this.$route.query.engagementId && this.$route.query.taskId){
          this.$router.push(`/engagements?companyId=${this.$route.query.companyId}&engagementId=${this.$route.query.engagementId}&taskId=${this.$route.query.taskId}`)
        }else if(this.$route.name === 'engagements' && this.$route.query.engagementId){
          this.$router.push(`/engagements?companyId=${this.$route.query.companyId}&engagementId=${this.$route.query.engagementId}`)
        }else{
          this.$router.push(`/engagements?companyId=${this.$route.query.companyId}`)
        }

        // Log e
        log(`/api/v1/logs/create?companyId=${this.$route.query.companyId}`, {
          'action': 'log_e',
          'paramsLog': {}
        })
      },
      goToCompanies(){
        if(this.$route.query.companyId){
          this.$router.push({ name: 'settings', query: { companyId: this.$route.query.companyId } })
        }else{
          this.$router.push({ name: 'settings' })
        }
      },
      goToProjects(){
        if(this.$route.name === 'projects' && this.$route.query.projectId && this.$route.query.taskId){
          this.$router.push(`/projects?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}&taskId=${this.$route.query.taskId}`)
        }else if(this.$route.name === 'projects' && this.$route.query.projectId){
          this.$router.push(`/projects?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}`)
        }else{
          this.$store.dispatch('getCompanyLayout').then(resp => {
            if(resp.lastProjectId){
              this.$router.push(`/projects?companyId=${this.$route.query.companyId}&projectId=${resp.lastProjectId}&taskId=0`)
            }else{
              this.$router.push(`/projects?companyId=${this.$route.query.companyId}`)
            }
          }).catch(err => {
            console.log(err)
          })
        }

        // Log p
        log(`/api/v1/logs/create?companyId=${this.$route.query.companyId}`, {
          'action': 'log_p',
          'paramsLog': {}
        })
      },
      closeModal() {
        this.$refs['form'].resetFields();
      },
      hideMenu() {
        // this.open = !this.open
        this.$emit('hideMenu');
      },
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      },
      // sharedCompanyPut(id, name){
      //   alert(name)
      //   this.$emit('companyName', name)
      //   localStorage.setItem('companyName', name);
      //   this.$emit('companyId', id)
      //   // this.valueCompany = id
      // },
      sentsInvite() {
        this.$refs['invite'].open()
      },
      submitForm(form) {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/advertising/system?email=${this.form.inviteEmail}`)
              .then(response => {
                // console.log('---', response.data);
                this.$refs.invite.close();
                loader.hide()
                this.notification("Success", "Invite Company", "success");
                this.$refs['form'].resetFields();
              })
              .catch(error => {
                console.log('An error occurred:', error);
                // this.$refs.invite.close();
                loader.hide()
              });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      sentsFeedback() {
        this.$refs['modal'].$refs['feedback'].open()
      },
      // setCompanyId(id, name) {
      //   // this.$socket.emit('companyChanged', id)
      //   // this.$route.query.companyId = id
      //   localStorage.setItem('companyId', id);
      //   localStorage.setItem('companyName', name);
      //   // this.$emit('companyId', id)
      //   this.$emit('companyName', name)
      //   this.$emit('companyId', id)
      //   this.$store.dispatch('companyChange', id)
      //   console.log('---PAGE', this.$route.name)
      //   switch (this.$route.name) {
      //     case 'projects':
      //       this.$router.push(`/projects?companyId=${id}`);
      //       this.$emit('setCompany')
      //       break;
      //     case 'business-units':
      //       this.$router.push(`/business-units?companyId=${id}`);
      //       this.$emit('setCompany')
      //       break;
      //     case 'shared-projects':
      //       this.$router.push(`/shared-projects?companyId=${id}`);
      //       this.$emit('setCompany')
      //       break;
      //     case 'users':
      //       this.$router.push(`/users?companyId=${id}`);
      //       this.$store.dispatch('getRowDataUsers');
      //       break;
      //     case 'clients':
      //       this.$router.push(`/clients?companyId=${id}`);
      //       this.$store.dispatch('getRowDataClients');
      //       // Clear rowDataClientsPerson
      //       this.$store.dispatch('getRowDataClientsPersonClear');
      //       break;
      //     case 'vendors':
      //       this.$router.push(`/vendors?companyId=${id}`);
      //       this.$store.dispatch('getRowDataVendors');
      //       // Clear rowDataVendorsPerson
      //       this.$store.dispatch('getRowDataVendorsPersonClear');
      //       break;
      //     case 'partners':
      //       this.$router.push(`/partners?companyId=${id}`);
      //       break;
      //     case 'my-regions':
      //       this.$router.push(`/my-regions?companyId=${id}`);
      //       this.$emit('setCompany')
      //       break;
      //     case 'business-centers':
      //       this.$router.push(`/business-centers?companyId=${id}`);
      //       this.$emit('setBU')
      //       break;
      //     case 'add-business-units':
      //       this.$router.push(`/add-business-units?companyId=${id}`);
      //       this.$emit('setBusinessUnits')
      //       break;
      //     case 'companies':
      //       this.$router.push(`/my-companies?companyId=${id}`);
      //       break;
      //     case 'permissions':
      //       this.$router.push(`/permissions?companyId=${id}`);
      //       this.$emit('setGroups')
      //       break;
      //     case 'about':
      //       this.$router.push(`/about?companyId=${id}`);
      //       // this.$emit('setCompany')
      //       break;
      //   }
      //   this.$store.dispatch('getMenuStatistics');
      //   localStorage.removeItem('selectedProjectId');
      //   localStorage.removeItem('selectedBusinessUnitId');
      // },
      openNews(title, time, content) {
        this.valueTitle = title
        this.valueTime = `Post time: ${moment(time * 1000).format("D MMM YY, h:mm a")}`,
          this.valueContent = content
        this.$refs['news'].open()
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
    },
  }
</script>

<style lang="scss" scoped>
  /deep/.sweet-modal .sweet-title .sweet-title-sub {
    width: 40%;
  }
    .menu {
        display: flex;
        flex-direction: column;
        margin-left: -260px;
        width: 260px;
        height: 100%;
        padding: 10px 10px 60px 10px;
        background: #EFF4F8;
        font-size: 18px;
        // box-shadow: 0 0 10px rgba(0,0,0,0.5);
        z-index: 998;
        transition: margin-left 500ms ease-out, transform 500ms ease-out;
        &__opened {
            transform: translateX(0);
        }
        &__header {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-bottom: 9px;

            img {
                margin-bottom: 10px;
            }
            // Menu
            .hamburger {
                width: 25px;
                height: 25px;
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                cursor: pointer;
                &__item {
                    height: 3px;
                    background: #fff;
                }
            }
        }
        &__content {
            width: 230px;
            .stat {
                text-align: center;
                margin-right: 6px;
                padding: 2px 7px;
                font-size: 13px;
                font-weight: bold;
                color: #409EFF;
                border-radius: 50%;
                border: 1px solid #409EFF;
            }
        }
        &__footer {
            margin-top: auto;
            color: #303133;
            span {
                font-size: 12px;
            }
        }
        &__info {
            margin-top: 10px;
            margin-left: 10px;
            font-size: 14px;
            color: #e8444c;
            cursor: pointer;
            &_title {
                padding: 10px 0 10px 0px;
                cursor: pointer;
            }
            &_item {
                padding: 5px 0 5px 20px;
                cursor: pointer;
                &:hover {
                    background-color: rgb(16, 22,30);
                }
            }
        }
        &__invite {
            font-size: 14px;
            line-height: 40px;
            // margin-bottom: 10px;
            padding-left: 10px;
            border-top: 1px solid #c2c3c6;
            border-bottom: 1px solid #c2c3c6;
            cursor: pointer;
            transition: background-color .3s,color .3s;
            &:hover {
                color: #fff;
                background-color: #c2c3c6;
            }
        }
        &__size {
          font-size: 13px;
          height: 40px;
          padding: 12px 10px;
          margin: auto 0;
          border-top: 1px solid #c2c3c6;
          transition: background-color .3s,color .3s;
          &_item {
            display: inline-block;
            width: 50%;
          }
        }
        &__feedback {
            font-size: 14px;
            line-height: 40px;
            margin-bottom: 10px;
            padding-left: 10px;
            color: #409EFF;
            cursor: pointer;
            border-top: 1px solid #c2c3c6;
            border-bottom: 1px solid #c2c3c6;
            transition: background-color .3s,color .3s;
            &:hover {
                color: #fff;
                background-color: #c2c3c6;
            }
        }
    }
    .animation {
        margin-left: 0;
        transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
    // [ Modal ] start
    .modal {
        &__time {
            position: absolute;
            top: 32px;
            left: 32px;
            color: #ccc;
        }
        &__title {
            text-align: center;
        }
        &__content {
            max-height: 400px;
            overflow: auto;
        }
        &__btn {
            text-align: right;
        }
    }
    .colorMenu {
        color: #303133 !important;
    }
    // [ Modal ] end
    .el-submenu {
        // border-top: 1px solid #383838;
        // &:first-child {
        //   border-top: none;
        // }
        &:last-child {
            // border-bottom: 1px solid #383838;
        }
    }
    .el-submenu .el-menu-item {
        font-size: 14px !important;
        height: 30px !important;
        line-height: 30px !important;
        padding-left: 25px !important;
        &:hover {
          background-color: rgb(242, 244, 247) !important;
        }
    }
</style>

<style lang="scss">
    // 3 lev
    .el-menu.el-menu--inline .el-submenu__title {
        padding-left: 25px !important;
    }

    .el-menu.el-menu--inline .el-submenu {
        border: none !important;
    }

    .el-menu.el-menu--inline .el-submenu .el-menu.el-menu--inline {
        padding-left: 20px !important;
    }
    // -----------

    .el-menu {
        border-right: none !important;
    }

    .el-submenu__title {
        font-size: 14px !important;
        height: 40px !important;
        line-height: 40px !important;
        padding: 0 10px !important;
        color: #4277A6 !important;
        &:hover {
          background-color: rgb(242, 244, 247) !important;
        }
    }

    .el-submenu__icon-arrow {
        right: 10px !important;
    }

    .el-submenu__title * {
        // font-size: 18px;
    }



    .el-menu-item-group__title {
        display: none;
    }

    .input{
        box-sizing: border-box;
        .el-input__inner{
            width:210px;
            margin-left: 20px;
        }
    }

    .flex {
        display: flex;
        justify-content: space-between;
    }

    .menu_title {
      padding: 0 10px;
      height: 40px;
      line-height: 40px;
      color: #4277A6;
      font-size: 13px;
      // font-weight: bold;
    }

    .tf-support {
      font-size: 20px;
    }

    .support_link {
      &:hover {
        color: red !important;
      }
    }
</style>
